import validateTagsSize from './validateTagsSize'

const tags = { validateTagsSize }

export default tags
